import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { GlobalDataService } from "src/app/services/global-data.service";

@Injectable({
  providedIn: "root",
})
export class MallMapsGuard implements CanActivate {
  constructor(private router: Router, private globalData: GlobalDataService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const initialMallData = this.globalData.getGlobalData();

      if (initialMallData.general.mapsEnabled) {
        resolve(true);
      } else {
        this.router.navigateByUrl("/");
        resolve(false);
      }
    });
  }
}
